













import Vue from "vue";
import Component from "vue-class-component";

import BaseApp from "../../BaseApp.vue";
import AppSimple from "./simple/AppSimple.vue";
import AppComplet from "./complet/AppComplet.vue";

import { decodeServerPayload } from "../../shared/logic/utils";
import { MetaInscription } from "@/shared/logic/types";
import { devMode } from "../../shared/logic/controller";

@Component({
  components: { BaseApp, AppSimple, AppComplet }
})
export default class App extends Vue {
  meta = devMode
    ? {
        is_complet: true,
        label_camp_simple: ""
      }
    : decodeServerPayload<MetaInscription>();

  get title() {
    if (this.meta == null) return "Erreur";
    if (this.meta.is_complet) return "Portail des inscriptions";
    return "Portail des inscriptions - Séjour " + this.meta.label_camp_simple;
  }
}
